import { render, staticRenderFns } from "./ButtonInput.vue?vue&type=template&id=00830a84&scoped=true&lang=pug&"
import script from "./ButtonInput.vue?vue&type=script&lang=ts&"
export * from "./ButtonInput.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonInput.vue?vue&type=style&index=0&id=00830a84&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00830a84",
  null
  
)

export default component.exports